/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import loadingConfig from "./config/loading.config.json";
import { IGetIssuedNetworkProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "IssuedNetworkPageService";
const log: any = LoggerModule.getInstance();

export type IIssuedNetworkPageSrvGetPageContentArgs = IGetIssuedNetworkProps;

export class IssuedNetworkPageService {
  private static instance: IssuedNetworkPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): IssuedNetworkPageService {
    if (!IssuedNetworkPageService.instance) {
      IssuedNetworkPageService.instance = new IssuedNetworkPageService(props);
    }
    return IssuedNetworkPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: IIssuedNetworkPageSrvGetPageContentArgs) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Header Props
    compProps = await agent.getHeaderProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Network Props
    compProps = await agent.getNetworkProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
  public getLoading() {
    return { ...(loadingConfig || {}) };
  }
}
